{
  "00945c89f76b547f": "Calificación",
  "487347e074fb8050": "Error al enviar la solicitud de tarifa",
  "7da032c39f057ad2": "Las solicitudes duplicadas en los últimos {{lookBackDays}} días no están permitidas.",
  "917e144e4bc3da89": "Enviar solicitud",
  "9f8669337c8da10b": "Solicitud de tarifa enviada. Su CSM se comunicará dentro de 1 día hábil."
}
